/**
 * Converte planos da API para formato do formulário
 * Funciona para bot e offer
 */
export function apiPlansToForm(data) {
  try {
    // ✅ Pega os campos corretos dependendo do tipo
    const names = safeJsonParse(data.plan_names || data.offer_names || "[]");
    const durations = safeJsonParse(data.plan_duration || data.offer_duration || "[]");
    const values = safeJsonParse(data.pix_values || data.offer_values || "[]");

    // ✅ Se estiver vazio, retorna array vazio
    if (!names || names.length === 0) {
      return [{ name: "", value: "", duration: "mensal" }];
    }

    return names.map((name, index) => ({
      name: name ?? "",
      value: values[index] !== undefined ? String(values[index]).trim() : "",
      duration: durations[index] ?? "mensal",
    }));
  } catch (err) {
    console.error("Erro ao converter planos da API:", err);
    return [{ name: "", value: "", duration: "mensal" }];
  }
}

/**
 * Extrai a entrega por plano (array paralelo alinhado por índice) a partir dos
 * objetos completos `plans` retornados pela API. Cada item é o dict `delivery`
 * do plano ou null (= entrega padrão do fluxo). Serve bot/upsell/disparo.
 */
export function deliveriesFromApi(data) {
  const plans = Array.isArray(data?.plans) ? data.plans : [];
  const names = safeJsonParse(data?.plan_names || data?.offer_names || "[]");
  const len = names.length || plans.length;
  return Array.from({ length: len }, (_, i) => plans[i]?.delivery || null);
}

/**
 * Parser JSON seguro - trata dupla codificação
 */
function safeJsonParse(value) {
  if (!value) return [];
  
  try {
    let parsed = value;
    
    // ✅ Se for string, faz parse
    if (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }
    
    // ✅ Se o resultado for string novamente, faz parse de novo
    if (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }
    
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.warn(`Erro ao fazer parse de: ${value}`, err);
    return [];
  }
}